import { api } from "@/lib/api";
import { toast } from "sonner";
import { terminGeaendert } from "@/lib/windowSync";

// GO für einen Termin (eine Stelle für Terminliste UND Kalender-Seitenleiste, 03.11.2026):
// Rückfrage, PATCH /module-termine/{id}/go (Status Wartet auf GO → Bestätigt), Meldung an die anderen Fenster.
// true = bestätigt (danach den Empfänger-Dialog TerminSendDialog öffnen: ICS-Mail an Kalender/Monteur/Kunde, danach Status „Im Kalender“).
export const terminBestaetigen = async (t, datumText = "") => {
  if (!window.confirm(
    `"${t.titel}"${datumText ? ` am ${datumText}` : ""} bestätigen?\n\n` +
    `Status wechselt von "Wartet auf GO" → "Bestätigt".\n` +
    `Im Anschluss kannst du wählen, an wen die ICS-Mail geschickt wird.`
  )) return false;
  try {
    await api.patch(`/module-termine/${t.id}/go`);
    terminGeaendert();
    toast.success("Termin bestätigt – jetzt Empfänger wählen");
    return true;
  } catch (err) {
    toast.error(err?.response?.data?.detail || "GO fehlgeschlagen");
    return false;
  }
};
